// Actions
export const setAssetsMaturity = ({ commit }, payload) => {
  commit('SET_ASSETS_MATURITY', payload)
}
export const addAssetsMaturity = ({ commit }, payload) => {
  commit('ADD_ASSETS_MATURITY', payload)
}
export const setAssetsMaturityLoading = ({ commit }, payload) => {
  commit('SET_ASSETS_MATURITY_LOADING', payload)
}

export const setAssetsApproaching = ({ commit }, payload) => {
  commit('SET_ASSETS_APPROACHING', payload)
}
export const addAssetsApproaching = ({ commit }, payload) => {
  commit('ADD_ASSETS_APPROACHING', payload)
}
export const setAssetsApproachingLoading = ({ commit }, payload) => {
  commit('SET_ASSETS_APPROACHING_LOADING', payload)
}
export const setExportTaxes = ({ commit }, payload) => {
  commit('SET_EXPORT_TAXES', payload)
}
export const addExportTaxes = ({ commit }, payload) => {
  commit('ADD_EXPORT_TAXES', payload)
}
export const setExportTaxesLoading = ({ commit }, payload) => {
  commit('SET_EXPORT_TAXES_LOADING', payload)
}

export const setCarteiraAdministrada = ({ commit }, payload) => {
  commit('SET_CARTEIRA_ADMINISTRADA', payload)
}
export const addCarteiraAdministrada = ({ commit }, payload) => {
  commit('ADD_CARTEIRA_ADMINISTRADA', payload)
}
export const setCarteiraAdministradaLoading = ({ commit }, payload) => {
  commit('SET_CARTEIRA_ADMINISTRADA_LOADING', payload)
}

